
import Effects from 'Effects';
import {isMobile} from 'react-device-detect';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Tone from 'tone';
import {AbstractParameter,
        } from 'parameters/AbstractParameter.js';

class Granulator extends Effects.Effect {

    constructor(sequencerEngine) {
        super('Granulator', () => new Tone.Gain(1) , sequencerEngine, true);; 
        this.outputNode = new Tone.Gain(1);
        this.loadedValue = 1;
        this.initializeWorklets();
        this.updateInitialValues();
   }

    connect(o) {
        this.outputNode.connect(o);
    }

    disconnect(o) {
        this.outputNode.disconnect(o);
    }

    async initializeWorklets() {
        if (isMobile || this.sequencerEngine.isOffline) {
            // then we dont do anything just connec the the input to output
            this.effectNode.connect(this.outputNode);
        } else {
            await this.sequencerEngine.initAudioWorklets();
            this.granulator = new AudioWorkletNode(Tone.Master.context._context, 'granulator-node');
            this.effectNode.connect(this.granulator);
            this.granulator.connect(this.outputNode);
        }
       this.updateInitialValues();
    }

    get documented() {
        return "Reduces the volume of loud sounds or amplifies quiet sounds.";
    }

    getJson(isPreset) {
        let json = super.getJson();
        return json;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        return bulk;
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new Granulator(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default Granulator;
